<template>
    <div class="apply-profile-modal-overlay">
        <div class="apply-profile-modal">
            <div class="apply-profile-modal-left-panel">
                <div class="apply-profile-modal-left-panel-body">
                    <ProfileSelection style="width:300px" :account_type="'school'" @profileSelected="profileSelected"
                        v-model="isProfileMinimized">
                    </ProfileSelection>
                </div>
                <div class="apply-profile-modal-left-panel-options row">
                    <widgetButton :loading="loadingDownloadingCv" @click="downloadCv()" class="btn-primary">
                        Download Cv
                    </widgetButton>
                    <div class="h-spacer"></div>
                    <widgetButton :loading="false" @click="closeModal()" class="btn-transparent">
                        Close
                    </widgetButton>
                </div>
            </div>
            <div class="apply-profile-modal-right-panel">
                <div class="apply-profile-modal-right-panel-header">
                    <widgetButton v-if="fullProfileData.hasData" @click="editAppliedCv()" class="btn-primary btn-edit-cv">
                        Edit Cv
                    </widgetButton>
                </div>
                <div class="apply-profile-modal-right-panel-body">
                    <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="isLoading"
                        :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
                    <div v-if="!isLoading" class="cv-template-page-wrapper">
                        <div class="cv-page-container" v-for="(page, pageIndex) in layers" :key="pageIndex">
                            <div class="cv-template-page" :id="page.itemId" :layer-level="0" :layer-index="pageIndex"
                                :layer-type="page.itemType" layer-parent-type="none" :layer-parent-index="null"
                                :layer-index-path="JSON.stringify([pageIndex])">

                                <template v-for="(item, index) in page.children">
                                    <template
                                        v-if="item.itemType == 'container_element' && item.dataOrigin != '' && !isApplyingProfile">
                                        <EditorTemplateElementViewer v-for="(n, j) in item.numberOfItems"
                                            :key="'goust_' + j + n" :layer="item" :itemLayerIndex="index"
                                            :itemLayerLever="1" :isGuostItem="j > 0"
                                            :GuostItemIndex="item.dataStartAt + j - 1" :itemParentLayerType="page.itemType"
                                            :itemLayerIndexPath="[pageIndex]" :readonly="true">
                                        </EditorTemplateElementViewer>
                                    </template>
                                    <EditorTemplateElementViewer v-else :key="index" :layer="item" :itemLayerIndex="index"
                                        :itemLayerLever="1" :itemParentLayerType="page.itemType"
                                        :itemLayerIndexPath="[pageIndex]" :readonly="true"
                                        :isApplyingProfile="isApplyingProfile">
                                    </EditorTemplateElementViewer>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { eventBus } from "@/main";
import ProfileSelection from "./profile_selection.vue";
import EditorTemplateElementViewer from "../components/editor_template_element_viewer.vue";
import { SITE_API, ACCOUNT_TYPE, FILE_MAKER_SERVER_BASE_URL } from "@/Store/variable.js";
export default {
    name: "apply-profile-modal",
    components: {
        ProfileSelection,
        EditorTemplateElementViewer
    },
    props: {
        pages: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            isProfileMinimized: false,
            isApplyingProfile: false,
            isLoading: false,
            fullProfileData: {
                hasData: false,
                profile: {
                    profile_id: null,
                    profile_first_name: '',
                    profile_last_name: '',
                    profile_image: '',
                    profile_email: '',
                    profile_phone: '',
                    profile_address: '',
                    profile_description: '',
                },
                projects: [],
                employments: [],
                educations: [],
                trainings: [],
                certifications: [],
                skills: [],
                skillsObject: null
            },
            loadingDownloadingCv: false,
            currentyProfileDataIndexing: {
                projects: 0,
                employments: 0,
                educations: 0,
                trainings: 0,
                certifications: 0,
                skills: 0
            },
            layers: [],
            profileContentSections: [],
            outboundedItems: [],
            inboundItemsToBeRemoved: [],
        };
    },
    computed: {

    },
    mounted() {
        let vm = this;
        // eslint-disable-next-line no-undef
        vm.layers = structuredClone(vm.pages);
    },
    methods: {
        editAppliedCv() {
            let vm = this;
            vm.$emit('editAppliedCv', { layers: vm.layers, template: vm.pages, profile: vm.fullProfileData });
        },
        assignProfileDataOnPage(parent, children) {
            let vm = this;
            if (vm.fullProfileData.hasData) {
                let processedChildren = [];
                processedChildren = children.map((child) => {
                    if (child.itemType == 'text_element' && child.dataOriginOwner == 'profile' && child.dataOrigin) {
                        let profileText = vm.fullProfileData.profile[child.dataOrigin];
                        child.textValue = profileText;
                    }
                    if (child.itemType == 'image_element' && child.dataOriginOwner == 'profile' && child.dataOrigin) {
                        let fileName = vm.fullProfileData.profile[child.dataOrigin];
                        child.imageSrc = fileName ? SITE_API + "/super-manager/cvs/image/download?name=" + fileName : child.imageSrc
                    }

                    if (child.itemType == 'container_element') {
                        if (child.dataOrigin) {
                            // eslint-disable-next-line no-undef
                            let virtualChild = structuredClone(child);
                            let profileItemNumber = vm.fullProfileData[child.dataOrigin].length > child.numberOfItems ? child.numberOfItems : vm.fullProfileData[child.dataOrigin].length;
                            let profileItemData = new Array(profileItemNumber).fill(0);
                            profileItemData = profileItemData.map((item, index) => {
                                let data = vm.processProfileItem(child.dataOrigin, virtualChild, index);
                                data.itemId = 'item_' + vm.$makeId(20);
                                vm.currentyProfileDataIndexing[child.dataOrigin] += 1;
                                // eslint-disable-next-line no-undef
                                return structuredClone(data);
                            });
                            child['hasProfileContent'] = true;
                            child.children = profileItemData;
                            child.flexDirection = parent.flexDirection;
                            child.justifyContent = parent.justifyContent;
                            child.alignItems = parent.alignItems;
                            child.flexWrap = parent.flexWrap;
                            child.display = parent.display;
                        } else {
                            child['hasProfileContent'] = false;
                            child.children = vm.assignProfileDataOnPage(child, child.children);
                        }
                    }
                    return child;
                });
                return processedChildren;
            }
            return children;
        },
        processProfileItem(dataOriginOwner, child, i) {
            let vm = this;
            eventBus.$set(vm.fullProfileData[dataOriginOwner][vm.currentyProfileDataIndexing[dataOriginOwner]], 'checked', true);
            child.children = child.children.map((item) => {
                item.itemId = 'item_' + vm.$makeId(20);
                if (item.itemType == 'text_element' && item.dataOrigin) {
                    if (item.dataOrigin != 'project_skills' || item.dataOrigin != 'employment_skills') {
                        let profileText = vm.fullProfileData[dataOriginOwner][vm.currentyProfileDataIndexing[dataOriginOwner]][item.dataOrigin];
                        item.textValue = profileText;
                    }
                }
                else if (item.itemType == 'star_element' && item.dataOrigin) {
                    let profileSkillLevel = vm.fullProfileData[dataOriginOwner][vm.currentyProfileDataIndexing[dataOriginOwner]][item.dataOrigin];
                    item.numberOfItems = profileSkillLevel;
                }
                else if (item.itemType == 'container_element') {
                    return vm.processProfileItem(dataOriginOwner, item, i);
                }
                return item;
            });
            return child;
        },
        profileSelected(userProfile) {
            let vm = this;
            vm.fullProfileData.hasData = false;
            vm.currentyProfileDataIndexing = {
                projects: 0,
                employments: 0,
                educations: 0,
                trainings: 0,
                certifications: 0,
                skills: 0
            };
            // eslint-disable-next-line no-undef
            vm.layers = structuredClone(vm.pages);
            vm.isLoading = true;
            vm.$store
                .dispatch("GET_ME_PROFILE", {
                    id: userProfile.copy,
                    type: "student",
                })
                .then((response) => {
                    vm.joinPrepareProfileData(response.data, userProfile);
                })
                .catch((error) => {
                    vm.fullProfileData.hasData = false;
                    vm.isLoading = false;
                    console.error({ error });
                });
        },
        joinPrepareProfileData(profileData, userProfile) {
            let vm = this;
            vm.fullProfileData.profile.profile_id = userProfile.copy;
            vm.fullProfileData.profile.profile_first_name = userProfile.first_name;
            vm.fullProfileData.profile.profile_last_name = userProfile.last_name;
            vm.fullProfileData.profile.profile_email = userProfile.email;
            vm.fullProfileData.profile.profile_image = userProfile.profile_picture;
            let { skillsObject, skillsArray } = vm.processSkills(profileData.skills);
            if (userProfile.profile) {
                vm.fullProfileData.profile.profile_phone = userProfile.profile.phone;
                vm.fullProfileData.profile.profile_address = userProfile.profile.address;
                vm.fullProfileData.profile.profile_description = vm.htmlToText(userProfile.profile.description);
            }
            vm.fullProfileData.projects = profileData.projects.map(item => {
                let { skillsObject, skillsArray } = vm.processSkills(item.skills);
                return {
                    project_name: item.name,
                    project_company: item.company ? item.company.name : '',
                    project_address: item.address,
                    project_description: vm.htmlToText(item.description),
                    project_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
                    project_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
                    project_skills: skillsArray,
                }
            });
            vm.fullProfileData.employments = profileData.employment.map(item => {
                let { skillsObject, skillsArray } = vm.processSkills(item.skills);
                return {
                    employment_company: item.company ? item.company.name : '',
                    employment_position: item.role,
                    employment_address: item.address,
                    employment_description: vm.htmlToText(item.description),
                    employment_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
                    employment_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
                    employment_skills: skillsArray,
                }
            });
            vm.fullProfileData.educations = profileData.educations.map(item => {
                return {
                    education_school: item.organization,
                    education_degree: item.degree,
                    education_address: item.address,
                    education_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
                    education_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
                }
            });
            vm.fullProfileData.trainings = profileData.trainings.map(item => {
                return {
                    training_certificate: item.title,
                    training_institution: item.organization,
                    training_address: item.address,
                    training_start_date: item.from ? vm.moment(item.from).format('MMM DD YYYY') : '',
                    training_end_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
                }
            });
            vm.fullProfileData.certifications = profileData.certifications.map(item => {
                return {
                    certification_name: item.name,
                    certification_institution: item.organization,
                    certification_date: item.to ? vm.moment(item.to).format('MMM DD YYYY') : '',
                    certification_description: item.description
                }
            });
            vm.fullProfileData.skills = skillsArray;
            vm.fullProfileData.skillsObject = skillsObject;
            vm.isApplyingProfile = true;
            vm.fullProfileData.hasData = true;
            vm.isLoading = false;

            // Combine all data
            if (vm.fullProfileData.hasData) {
                //eslint-disable-next-line no-undef
                let layers = structuredClone(vm.pages);
                vm.layers = layers.map((page) => {
                    return {
                        ...page,
                        children: vm.assignProfileDataOnPage(page, page.children)
                    };
                });

                vm.layers.forEach((page, index) => {
                    vm.$nextTick(() => {
                        vm.fitPageContent(index);
                    });
                });
            }

        },
        // ==========
        fitPageContent(pageIndex = 0) {
            let vm = this;
            vm.profileContentSections = [];
            vm.getProfileContentSections(null, pageIndex);
            vm.outboundedItems = [];
            vm.inboundItemsToBeRemoved = [];
            let page = vm.layers[pageIndex];
            let pageDomEl = document.querySelector(`#${page.itemId}`);
            let pageRect = pageDomEl.getBoundingClientRect();
            vm.profileContentSections.forEach(item => {
                let profileContentSectionChildren = item.children;
                profileContentSectionChildren.forEach(itemChild => {
                    let child = document.querySelector(`#${itemChild.itemId}`);
                    let otherElementRect = child.getBoundingClientRect();

                    let isTopOutOfViewport = pageRect.bottom < otherElementRect.top;
                    if (isTopOutOfViewport) {
                        let outBoundItem = {
                            parentItemId: item.itemId,
                            isMainSestion: true,
                            item: itemChild,
                        }
                        vm.outboundedItems.push(outBoundItem);
                    } else {
                        let isBottomOutOfViewport = pageRect.bottom < otherElementRect.bottom;
                        if (isBottomOutOfViewport && itemChild.itemType == 'container_element') {
                            itemChild['foundItemOutbounded'] = false;
                            itemChild['foundItemInbounded'] = false;
                            vm.analizeItemsOutOfViewport(itemChild, itemChild, itemChild.children, pageRect);

                            if (!itemChild.foundItemOutbounded) {
                                vm.inboundItemsToBeRemoved.push({
                                    parentItemId: item.itemId,
                                    item: itemChild,
                                });
                            }

                            if (!itemChild.foundItemInbounded) {
                                let outBoundItem = {
                                    parentItemId: item.itemId,
                                    item: itemChild,
                                }
                                vm.outboundedItems.push(outBoundItem);
                            }

                        } else {
                            if (itemChild.itemType == 'container_element') {
                                vm.inboundItemsToBeRemoved.push({
                                    parentItemId: item.itemId,
                                    item: itemChild,
                                });
                            }
                        }
                    }
                });
            });

            if (vm.outboundedItems.length > 0) {
                vm.removeOutboundedItems(page.children);
                vm.prepareNextPage(pageIndex);
                vm.$nextTick(() => {
                    vm.fitPageContent(pageIndex + 1);
                });
            }
        },
        prepareNextPage(pageIndex = 0) {
            let vm = this;
            let pageContent = vm.layers[pageIndex];
            vm.fittingDuplicatePage(pageContent, pageIndex);
        },
        fittingDuplicatePage(page, pageIndex) {
            let vm = this;
            // eslint-disable-next-line no-undef
            let newPage = structuredClone(page);
            newPage.itemId = 'item_id_page_' + vm.$makeId(20);
            newPage.itemName = newPage.itemName + ' copy';
            // Process Main Section
            newPage.children = vm.fittingChangeChildrenId(newPage.children, true);
            // Process Inner Sections
            newPage.children = vm.fittingChangeChildrenId(newPage.children, false);
            // Update page  ids
            newPage.children = newPage.children.map(item => {
                return vm.changeChildrenId2(item);
            });
            vm.layers.splice(pageIndex + 1, 0, newPage);
        },
        fittingChangeChildrenId(items, processMainSection = false) {
            let vm = this;
            return items.map(item => {
                vm.inboundItemsToBeRemoved.forEach(inboundItem => {
                    if (item != null) {
                        if (item.itemId == inboundItem.item.itemId) {
                            item = null;
                        }
                    }
                });
                if (item) {
                    let foundItemChildren = vm.outboundedItems.filter(outboundedItem => outboundedItem.parentItemId == item.itemId && !outboundedItem.isMainSestion);
                    let foundItemForMainChildren = vm.outboundedItems.filter(outboundedItem => outboundedItem.parentItemId == item.itemId && outboundedItem.isMainSestion);
                    if (foundItemChildren.length > 0 && !processMainSection) {
                        let processedChildren = foundItemChildren.map(outboundedItem => {
                            return outboundedItem.item;
                        });
                        item.children = processedChildren;

                    } else if (foundItemForMainChildren.length > 0 && processMainSection) {
                        let a = structuredClone(item.children);
                        foundItemForMainChildren.forEach(outboundedItem => {
                            a.push(outboundedItem.item);
                        });
                        let processedChildren = a.map(outboundedItem => {
                            return outboundedItem;
                        });
                        item.children = processedChildren;
                    } else {
                        if (item.children) {
                            item.children = vm.fittingChangeChildrenId(item.children, processMainSection);
                        }
                    }
                    return item;
                }
                return null;
            }).filter(item => item != null);
        },
        changeChildrenId2(child) {
            let vm = this;
            child.itemId = 'item_id_' + vm.$makeId(20);
            if (child.children) {
                child.children = child.children.map(item => {
                    return vm.changeChildrenId2(item);
                });
            }
            return child;
        },
        removeOutboundedItems(children = null) {
            let vm = this;
            let items = children || vm.layers;
            let i = items.length;
            while (i--) {
                let item = items[i];
                vm.outboundedItems.forEach(outboundedItem => {
                    if (item.itemId == outboundedItem.item.itemId) {
                        items.splice(i, 1);
                    }
                });
                if (item.children) {
                    vm.removeOutboundedItems(item.children);
                }
            }
        },
        analizeItemsOutOfViewport(mainParent, parent, children, pageRect) {
            let vm = this;
            children.forEach((item, index) => {
                let child = document.querySelector(`#${item.itemId}`);
                let otherElementRect = child.getBoundingClientRect();
                let isOutOfViewport = pageRect.bottom < otherElementRect.bottom;
                if (isOutOfViewport && item.itemType == 'container_element' && item.dataOrigin != '' && !item.hasProfileContent) {
                    mainParent.foundItemOutbounded = true;
                    let outBoundItem = {
                        parentItemId: parent.itemId,
                        item: item,
                    }
                    vm.outboundedItems.push(outBoundItem);
                }
                if (!isOutOfViewport && item.itemType == 'container_element' && item.dataOrigin != '' && !item.hasProfileContent) {
                    mainParent.foundItemInbounded = true;
                }
                if (item.itemType == 'container_element') {
                    vm.analizeItemsOutOfViewport(mainParent, item, item.children, pageRect);
                }
            });
        },
        getProfileContentSections(children = null, pageIndex = 0) {
            let vm = this;
            let items = children || vm.layers[pageIndex].children;
            let stack = [...items];
            while (stack.length) {
                let item = stack.pop();
                if (item.itemType == 'container_element' && item.isProfileContent) {
                    // eslint-disable-next-line no-undef
                    vm.profileContentSections.push(structuredClone(item));
                }
                if (item.children) {
                    stack.push(...item.children);
                }
            }
        },
        // ============
        closeModal() {
            let vm = this;
            vm.$emit('close');
        },
        applyEffectToElementAndChildren(element) {
            let vm = this;
            // check if element is not svg
            if (element.tagName !== 'svg') {
                const attributes = element.getAttributeNames();
                for (const attribute of attributes) {
                    if (attribute !== 'style' && attribute !== 'src') {
                        element.removeAttribute(attribute);
                    }
                }
                const children = element.children;
                for (const child of children) {
                    vm.applyEffectToElementAndChildren(child);
                }
            }
        },
        downloadCv() {
            let vm = this;
            vm.loadingDownloadingCv = true;
            vm.$store.commit("SET_DOWNLOADING_CV", true);
            const pageDom = vm.layers.map((item, index) => {
                let parentPageEl = document.querySelector(`#${item.itemId}`).parentNode.cloneNode(true);
                let pageEl = parentPageEl.querySelector(`#${item.itemId}`);
                vm.applyEffectToElementAndChildren(pageEl);
                pageEl.style.removeProperty("width");
                pageEl.style.removeProperty("height");
                pageEl.classList.add("cv-template-page");
                return {
                    index: index,
                    page: pageEl.parentElement.innerHTML.replaceAll('<!---->', "")
                }
            });
            vm.$store
                .dispatch("CVS_GENELATE_FILE", {
                    pages: pageDom,
                })
                .then((response) => {
                    vm.loadingDownloadingCv = false;
                    vm.$store.commit("SET_DOWNLOADING_CV", false);
                    const url = FILE_MAKER_SERVER_BASE_URL + "/download/" + response.data.url;
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "cv.pdf");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    vm.loadingDownloadingCv = false;
                    vm.$store.commit("SET_DOWNLOADING_CV", false);
                });
        },
        processSkills(skills_data) {
            let skills = {
                tools: [],
                domains: [],
                languages: [],
                competences: [],
                roles: [],
            };
            let skillsArray = [];
            if (skills_data && skills_data.length > 0) {
                let i = 0;
                while (i < skills_data.length) {
                    let skill = skills_data[i];
                    let j = 0;
                    while (j < skill.tools.length) {
                        let item = skill.tools[j];
                        let obj = {
                            id: item.id,
                            name: item.name,
                            priority: item.priority,
                            editMode: false,
                            type: "tools",
                            order: item.order,
                            status: item.status,
                            searchable: item.status === 0 ? false : true,
                            level: parseInt(item.priority),
                        };
                        skills.tools.push(obj);
                        skillsArray.push(obj);
                        j++;
                    }
                    j = 0;
                    while (j < skill.domains.length) {
                        let item = skill.domains[j];
                        let obj = {
                            id: item.id,
                            name: item.name,
                            priority: item.priority,
                            editMode: false,
                            type: "domains",
                            order: item.order,
                            status: item.status,
                            searchable: item.status === 0 ? false : true,
                            level: parseInt(item.priority),
                        };
                        skills.domains.push(obj);
                        skillsArray.push(obj);
                        j++;
                    }
                    j = 0;
                    while (j < skill.competences.length) {
                        let item = skill.competences[j];
                        let obj = {
                            id: item.id,
                            name: item.name,
                            priority: item.priority,
                            editMode: false,
                            type: "competences",
                            order: item.order,
                            status: item.status,
                            searchable: item.status === 0 ? false : true,
                            level: parseInt(item.priority),
                        };
                        skills.competences.push(obj);
                        skillsArray.push(obj);
                        j++;
                    }
                    j = 0;
                    while (j < skill.roles.length) {
                        let item = skill.roles[j];
                        let obj = {
                            id: item.id,
                            name: item.name,
                            priority: item.priority,
                            editMode: false,
                            type: "roles",
                            order: item.order,
                            status: item.status,
                            searchable: item.status === 0 ? false : true,
                            level: parseInt(item.priority),
                        };
                        skills.roles.push(obj);
                        skillsArray.push(obj);
                        j++;
                    }
                    j = 0;
                    while (j < skill.languages.length) {
                        let item = skill.languages[j];
                        if (item.lang) {
                            let obj = {
                                id: item.id,
                                name: item.lang.name,
                                lang: item.lang.id,
                                editMode: false,
                                type: "languages",
                                order: item.order,
                                status: item.status,
                                searchable: item.status === 0 ? false : true,
                                level: parseInt(item.level),
                            };
                            skills.languages.push(obj);
                            skillsArray.push(obj);
                        }
                        j++;
                    }
                    i++;
                }
            }
            return {
                skillsObject: skills,
                skillsArray
            };
        },
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.apply-profile-modal-overlay {
    position: fixed;
    z-index: 999999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;

    .apply-profile-modal {
        margin: 0 auto;
        height: 90%;
        width: 95%;
        background-color: #fff;
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .apply-profile-modal-left-panel {
            width: 300px;
            height: 100%;
            background-color: #fff;
            border-radius: 5px;
            display: flex;
            flex-direction: column;

            .apply-profile-modal-left-panel-body {
                display: flex;
                flex-direction: column;
                height: calc(100% - 50px);
            }

            .apply-profile-modal-left-panel-options {
                height: 50px;
                display: flex;
                align-items: center;
                padding: 0px 5px;
            }
        }

        .apply-profile-modal-right-panel {
            width: calc(100% - 200px);
            height: 100%;
            background-color: #eae9e9;
            border-radius: 5px;
            position: relative;
            display: flex;
            flex-direction: column;

            .apply-profile-modal-right-panel-header {
                height: 45px;
                background: #fff;
                display: flex;
                align-items: center;
                padding: 0px 15px;
                justify-content: flex-end;

                .btn-edit-cv {}
            }

            .apply-profile-modal-right-panel-body {
                height: calc(100% - 45px);
                overflow: auto;

                .cv-template-page-wrapper {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: center;
                    zoom: 1;
                    padding: 50px 0px;

                    .cv-page-container {
                        height: 842px;
                        width: 595px;
                        background: #fff;
                        position: relative;
                        margin-bottom: 30px;

                        .cv-template-page {
                            position: relative;
                            background: #fff;
                            width: 595px;
                            height: 842px;
                        }
                    }
                }
            }
        }

    }
}
</style>